import { Theme, THEME_STORAGE_KEY, THEMES } from '@/shared/config';

export const themeInstall = (): Theme => {
  const storageTheme = localStorage.getItem(THEME_STORAGE_KEY) as Theme;

  if (storageTheme && THEMES.includes(storageTheme)) {
    return storageTheme;
  }

  return Theme.Dark;
};
